<template>
  <div class="access-page">
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">アクセス</h1>
        <p class="page-subtitle">教室へのアクセス情報をご案内します。</p>
      </div>
    </div>

    <section class="section address-section">
      <div class="container">
        <h2>教室所在地</h2>
        <div v-if="isLoading" class="loading-state">情報を読み込み中...</div>
        <div v-else-if="error" class="error-message">{{ error }}</div>
        <div v-else>
          <!-- 使用 pre 標籤或 CSS white-space: pre-wrap 來保留換行符 -->
          <p class="preserve-whitespace">{{ accessInfo.address || '住所情報が登録されていません。' }}</p>
          <p v-if="accessInfo.phone_number">電話: {{ accessInfo.phone_number }}</p>
        </div>
      </div>
    </section>

    <section class="section map-section">
      <div class="container">
        <h2>地図</h2>
        <div v-if="isLoading" class="loading-state">地図を読み込み中...</div>
         <div v-else-if="error" class="error-message">{{ error }}</div>
        <!-- 替換為 iframe -->
        <div v-else-if="accessInfo.google_maps_embed_url" class="map-container">
          <iframe
            :src="accessInfo.google_maps_embed_url"
            width="100%"
            height="450"
            style="border:0; border-radius: 8px;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div v-else class="map-placeholder">
          <p>地図情報が登録されていません。</p>
        </div>
      </div>
    </section>

     <section class="section transport-section">
       <div class="container">
         <h2>交通アクセス</h2>
         <div v-if="isLoading" class="loading-state">情報を読み込み中...</div>
          <div v-else-if="error" class="error-message">{{ error }}</div>
         <div v-else>
           <!-- 使用 pre 標籤或 CSS white-space: pre-wrap -->
           <p class="preserve-whitespace">{{ accessInfo.transport_info || '交通アクセス情報が登録されていません。' }}</p>
         </div>
       </div>
     </section>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const accessInfo = ref({});
const isLoading = ref(true);
const error = ref('');

const fetchAccessInfo = async () => {
  try {
    const response = await fetch('https://enen.saitsuki.uk/api/settings/access');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    accessInfo.value = data;
  } catch (err) {
    console.error("アクセス情報の取得エラー:", err);
    error.value = "情報の読み込み中にエラーが発生しました。";
  }
};

onMounted(async () => {
  isLoading.value = true;
  error.value = '';
  await fetchAccessInfo();
  isLoading.value = false;
});
</script>

<style scoped>
.access-page {
  padding-bottom: 50px;
}

.page-header {
  background-color: var(--secondary-color); /* Or another suitable color */
  color: white;
  padding: 50px 0;
  text-align: center;
  margin-bottom: 40px;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
}

.page-subtitle {
  font-size: 16px;
  opacity: 0.9;
}

.container {
  max-width: 900px; /* Slightly narrower for access page */
  margin: 0 auto;
  padding: 0 15px;
}

.section {
  padding: 30px 0;
  margin-bottom: 30px;
}

.section h2 {
  font-size: 22px;
  color: var(--primary-color);
  margin-bottom: 20px;
  border-bottom: 2px solid var(--primary-color);
  padding-bottom: 10px;
  display: inline-block;
}

.address-section p,
.transport-section p {
    line-height: 1.7;
    margin-bottom: 8px;
    color: #333; /* Ensure text color */
}

/* Style to preserve whitespace and newlines */
.preserve-whitespace {
    white-space: pre-wrap;
}

.map-container {
    width: 100%;
    height: 450px; /* Match iframe height */
    border-radius: 8px;
    overflow: hidden; /* Ensure iframe respects border-radius */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.map-placeholder {
  background-color: #eee;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  color: #777;
}

/* Loading and Error States */
.loading-state {
    text-align: center;
    padding: 30px;
    color: #777;
}
.error-message {
    color: #dc3545;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    padding: 15px;
    border-radius: 6px;
    text-align: center;
}
</style> 